import React from "react";

export default function ProductSlogan() {
  return (
    <div>
      <h3 className="h4-24-bold text-center lg:h2-40-bold text-dark-major">
        We build for collaborations
      </h3>
      <p className="p-16-normal lg:p-18-normal text-dark-minor text-center mt-4">
        The collaboration upon users' credit
      </p>
    </div>
  );
}
